// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-unauthorized .header-winnin-logo-unauthorized {
  display: block;
  margin: 22px 0;
}
.error-unauthorized .header-winnin-logo-unauthorized .pipe {
  display: inline-block;
}
.error-unauthorized .wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 680px;
}
.error-unauthorized .wrapper .text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--color_primary_500);
  position: relative;
}
.error-unauthorized .wrapper .text > * {
  max-width: 450px;
}
.error-unauthorized .wrapper .text .title {
  margin-bottom: 16px;
}
.error-unauthorized .wrapper .text .subtitle {
  margin-bottom: 36px;
}
.error-unauthorized .wrapper .text .unauthorized-button {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin: 40px 0 0;
}
.error-unauthorized .wrapper .contact .contact-text {
  color: var(--color_primary_500);
  font-size: 16px;
}
.error-unauthorized .wrapper .contact .contact-text.email {
  color: var(--gray_dark2);
}
.error-unauthorized .wrapper .image {
  align-self: center;
  flex: 1 1;
  height: 680px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/errors/eUnauthorized/index.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,cAAA;AAAJ;AAEI;EACE,qBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AAFJ;AAII;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAKM;EACE,mBAAA;AAHR;AAMM;EACE,mBAAA;AAJR;AAOM;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBAAA;AALR;AAUM;EACE,+BAAA;EACA,eAAA;AARR;AAUQ;EACE,wBAAA;AARV;AAaI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;AAXN","sourcesContent":[".error-unauthorized {\n  .header-winnin-logo-unauthorized {\n    display: block;\n    margin: 22px 0;\n\n    .pipe {\n      display: inline-block;\n    }\n  }\n\n  .wrapper {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 680px;\n\n    .text {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      color: var(--color_primary_500);\n      position: relative;\n\n      &>* {\n        max-width: 450px;\n      }\n\n      .title {\n        margin-bottom: 16px;\n      }\n\n      .subtitle {\n        margin-bottom: 36px;\n      }\n\n      .unauthorized-button {\n        width: fit-content;\n        margin: 40px 0 0;\n      }\n    }\n\n    .contact {\n      .contact-text {\n        color: var(--color_primary_500);\n        font-size: 16px;\n\n        &.email {\n          color: var(--gray_dark2);\n        }\n      }\n    }\n\n    .image {\n      align-self: center;\n      flex: 1;\n      height: 680px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
